import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

export const LightLeakCaustics: React.FC<{ opacity?: number }> = ({ opacity = 1 }) => {
  const frame = useCurrentFrame();

  const caustics = Array.from({ length: 5 }, (_, i) => {
    const cx = 30 + Math.sin((frame * 0.008 + i * 2.1)) * 25;
    const cy = 25 + Math.cos((frame * 0.006 + i * 1.7)) * 20;
    const rx = 20 + Math.sin((frame * 0.01 + i * 3.2)) * 12;
    const ry = 15 + Math.cos((frame * 0.012 + i * 2.5)) * 8;
    const rotation = frame * 0.2 + i * 72;
    const causticOpacity = 0.04 + Math.sin((frame * 0.015 + i * 1.3)) * 0.03;

    return { cx, cy, rx, ry, rotation, opacity: causticOpacity };
  });

  return (
    <AbsoluteFill style={{ opacity }}>
      {/* Warm light leak from top-left */}
      <div style={{
        position: "absolute",
        top: "-10%",
        left: "-5%",
        width: "60%",
        height: "60%",
        background: `radial-gradient(ellipse at 30% 30%, rgba(243,112,33,${0.06 + Math.sin(frame / 50) * 0.03}) 0%, transparent 70%)`,
      }} />
      {/* Caustic patterns */}
      {caustics.map((c, i) => (
        <div key={i} style={{
          position: "absolute",
          left: `${c.cx}%`,
          top: `${c.cy}%`,
          width: `${c.rx}%`,
          height: `${c.ry}%`,
          borderRadius: "50%",
          background: `radial-gradient(ellipse, rgba(212,168,67,${c.opacity}) 0%, transparent 70%)`,
          transform: `rotate(${c.rotation}deg)`,
        }} />
      ))}
      {/* Golden hour glow bottom */}
      <div style={{
        position: "absolute",
        bottom: "-5%",
        right: "-5%",
        width: "50%",
        height: "40%",
        background: `radial-gradient(ellipse at 70% 80%, rgba(212,168,67,${0.04 + Math.sin(frame / 60) * 0.02}) 0%, transparent 70%)`,
      }} />
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
